import type { SubmitResponse } from '@feedback-service/shared'

import type { FeedbackFormData } from '@/types/feedback'

function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_URL || ''
}

export async function submitFeedback(data: FeedbackFormData): Promise<SubmitResponse> {
  const formData = new FormData();
  formData.append('description', data.description);
  formData.append('category', data.category);
  formData.append('appId', data.appId);

  if (data.rating) {
    formData.append('rating', data.rating);
  }

  if (data.userEmail) {
    formData.append('userEmail', data.userEmail);
  }

  if (data.userName) {
    formData.append('userName', data.userName);
  }

  if (data.images && data.images.length > 0) {
    data.images.forEach((image) => {
      formData.append('images', image);
    });
  }

  const apiBaseUrl = getApiBaseUrl();
  const apiUrl = apiBaseUrl ? `${apiBaseUrl}/api/feedback` : '/api/feedback';

  const response = await fetch(apiUrl, {
    method: 'POST',
    body: formData,
  });

  const result = await response.json();

  if (!response.ok) {
    const errorMessage = result.error?.message;
    throw new Error(errorMessage || 'Failed to submit feedback');
  }

  return result;
}
